module.exports = __webpack_public_path__ + "static/img/phone-01.5f98f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-01.png
// module id = au6V
// module chunks = 45